"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBudgetQuestion = void 0;
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _utils = require("../../utils/utils");
var _services = require("../../services");
var _react = require("react");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _useUserSessionStatus = require("../user/useUserSessionStatus");
var _useQuestionnaireNavigation = require("./useQuestionnaireNavigation");
var _lodash = _interopRequireDefault(require("lodash.isempty"));
var _constants = require("../../utils/constants");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useBudgetQuestion = question => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    onSkip
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const budget = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectBudget);
  const budgetQuestion = (0, _utils.clone)(question);
  const {
    minValue,
    minPlanValueAdjusted,
    minHandsetValueAdjusted,
    recommendedPlanPrice,
    recommendedHandsetPrice,
    maxValue,
    maxPlanValueAdjusted,
    maxHandsetValueAdjusted,
    lastSelectedBudget,
    lastSelectedPlanBudget
  } = budget;
  const isBudgetReady = !(0, _lodash.default)(budget);
  const shouldSkipQuestion = isBudgetReady && (minValue === maxValue || !maxValue || !minValue);
  const [isRecommendedValueAssigned, setIsRecommendedValueAssigned] = (0, _react.useState)(false);
  const {
    isSavingUserSession
  } = (0, _useUserSessionStatus.useUserSessionStatus)();
  const [shouldFetchBudget, setShouldFetchBudget] = (0, _react.useState)(false);
  const defaultSelection = budgetQuestion.type === _constants.QUESTION_TYPE.MULTI ? budgetQuestion.multi.length > 1 ? budgetQuestion.multi[0].rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? [recommendedHandsetPrice, recommendedPlanPrice] : [recommendedPlanPrice, recommendedHandsetPrice] : budgetQuestion.multi[0].rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? [recommendedHandsetPrice] : [recommendedPlanPrice] : budgetQuestion.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? [recommendedHandsetPrice] : [recommendedPlanPrice];
  (0, _react.useEffect)(() => {
    if (!isSavingUserSession && !shouldFetchBudget) {
      setShouldFetchBudget(true);
    }
  }, [isSavingUserSession]);
  (0, _react.useEffect)(() => {
    if (!isBudgetReady && shouldFetchBudget) {
      dispatch((0, _questionnaireActions.resetSelections)());
      dispatch((0, _questionnaireActions.fetchBudget)());
      setIsRecommendedValueAssigned(false);
    }
  }, [shouldFetchBudget]);
  (0, _react.useEffect)(() => {
    if (!isRecommendedValueAssigned && isBudgetReady) {
      if (lastSelectedBudget || lastSelectedPlanBudget) return;
      defaultSelection.forEach((value, index) => {
        dispatch((0, _questionnaireActions.replaceSelection)(value, index));
      });
      setIsRecommendedValueAssigned(true);
    }
  }, [defaultSelection]);
  (0, _react.useEffect)(() => {
    if (shouldSkipQuestion) {
      onSkip();
    }
  }, [shouldSkipQuestion]);
  const onAdjustBudget = (selection, question) => {
    if (selection === lastSelectedBudget || selection === lastSelectedPlanBudget) {
      dispatch((0, _questionnaireActions.adjustBudget)(false));
    } else {
      (0, _questionnaireUtil.getQuestionProductType)(question) === _constants.PRODUCT_TYPES.HANDSET ? dispatch((0, _questionnaireActions.setBudget)({
        ...budget,
        lastSelectedBudget: selection
      })) : dispatch((0, _questionnaireActions.setBudget)({
        ...budget,
        lastSelectedPlanBudget: selection
      }));
      dispatch((0, _questionnaireActions.adjustBudget)(true));
    }
  };
  if (budgetQuestion.type === _constants.QUESTION_TYPE.MULTI) {
    budgetQuestion.multi = budgetQuestion.multi.map(multiSegment => {
      const minValueAdjusted = multiSegment.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? minHandsetValueAdjusted : minPlanValueAdjusted;
      const maxValueAdjusted = multiSegment.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? maxHandsetValueAdjusted : maxPlanValueAdjusted;
      return {
        ...multiSegment,
        id: _constants.QUESTION_ID.BUDGET,
        rangeChoices: {
          min: minValueAdjusted,
          max: maxValueAdjusted,
          shouldSkipSegment: minValueAdjusted === maxValueAdjusted,
          minLabel: _services.locale.formatPrice(minValueAdjusted, {
            fraction: false
          }),
          maxLabel: _services.locale.formatPrice(maxValueAdjusted, {
            fraction: false
          })
        }
      };
    });
  } else {
    const minValueAdjusted = budgetQuestion.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? minHandsetValueAdjusted : minPlanValueAdjusted;
    const maxValueAdjusted = budgetQuestion.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? maxHandsetValueAdjusted : maxPlanValueAdjusted;
    budgetQuestion.rangeChoices = {
      min: minValueAdjusted,
      max: maxValueAdjusted,
      shouldSkipSegment: minValueAdjusted === maxValueAdjusted,
      minLabel: _services.locale.formatPrice(minValueAdjusted, {
        fraction: false
      }),
      maxLabel: _services.locale.formatPrice(maxValueAdjusted, {
        fraction: false
      })
    };
  }
  return {
    isBudgetReady,
    budgetQuestion,
    adjustBudget: onAdjustBudget,
    defaultSelection
  };
};
exports.useBudgetQuestion = useBudgetQuestion;